import { createEvent, createStore, sample } from 'effector'

import { ClientError, fx, mapResponseError } from '../../../libs'
import { Comment } from './types'
import { commentListBackendUpdated } from '../commentList/model'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../features/notifications'

export const mounted = createEvent()

export const submitForm = createEvent<Comment>()

export const comment = fx<Comment, Comment>({
  method: 'POST',
  url: '/comment',
})

sample({
  clock: submitForm,
  fn: ({ message, visibility, entityType, entityId, department, type }) => {
    return {
      body: {
        entityType,
        message,
        visibility,
        entityId,
        department,
        type,
      },
    }
  },
  target: comment,
})
sample({
  clock: [comment.doneData],
  fn: (doneData) => {
    return {
      entityType: doneData.body.entityType,
      entityId: doneData.body.entityId,
    }
  },
  target: [commentListBackendUpdated],
})
sample({
  clock: comment.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: comment.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})

export const $error = createStore<ClientError<Comment> | null>(null)

$error
  .on(comment.failData, (_, failData) =>
    mapResponseError<Comment>(failData.body),
  )
  .reset([mounted, submitForm])
